import { CoursesTab } from '../../academics/components/CoursesTab';

export function CoursesPage() {
  return (
    <div className="space-y-6">
      <CoursesTab />
    </div>
  );
}
